import type { ReactElement } from 'react';

export interface SeoFactProps {
    icon: ReactElement;
    title: string;
    value: string | ReactElement;
}

export const DestinationFact = ({ icon, title, value }: SeoFactProps) => (
    <div className="mb-16">
        <div className="inline-block mr-24" data-testid="seoFactIcon">
            {icon}
        </div>
        <div className="inline-block">
            <div data-testid="seoFactTitle">{title}</div>
            <div className="capitalize font-bold" data-testid="seoFactValue">
                {value}
            </div>
        </div>
    </div>
);
